import { FC, CSSProperties } from 'react';
import { Field as FieldReact } from 'react-final-form';
import { IconName, Icon } from '../Icon';
import { valueType } from 'antd/lib/statistic/utils';
import { LabelInput } from './styles';

export interface IField {
  label: string;
  name: string;
  placeholder?: string;
  style?: CSSProperties;
  className?: string;
  icon?: IconName;
  type?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  value?: string;
  defaultValue?: string | number | undefined;
  maxLenght?: number;
  typeInput?: string;
  outError?: string;
  height?: string;
  controledInput?: boolean;
  rightIcon?: IconName;
  rightIconSize?: number;
  parse?: (value: any, name: string) => valueType;
  onFocus?: () => void;
  onBlur?: () => void;
  onClick?: () => void;
  onInput?: (value: string) => void;
  onChange?: (e?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onCustomChange?: (value: string) => void;
  onRightIconClick?: () => void;
}

const hasError = (meta: any, disabled?: boolean) =>
  !disabled && meta.invalid && meta.touched;

const Field: FC<IField> = ({
  label,
  style,
  className,
  name,
  defaultValue,
  icon,
  type = 'text',
  placeholder = label,
  disabled,
  autoFocus,
  value,
  maxLenght,
  typeInput,
  outError,
  height,
  controledInput,
  rightIcon,
  rightIconSize,
  onFocus,
  onBlur,
  onClick,
  onInput,
  onChange,
  onCustomChange,
  parse,
  onRightIconClick,
}) => {
  return (
    <FieldReact
      name={name}
      type={type}
      defaultValue={defaultValue}
      initialValue={value}
      parse={parse}
      typeInput={typeInput}
    >
      {controledInput ? (
        (props) => {
          props.meta.active ? onFocus && onFocus() : onBlur && onBlur();

          return (
            <LabelInput
              hidden={type === 'hidden'}
              className={className || ''}
              hasicon={!!icon}
              isdisabled={disabled}
              invalid={hasError(props.meta, disabled) && !props.meta.active}
              style={style}
              height={height}
            >
              {icon ? <Icon icon={icon} className="fieldIcon" /> : ''}
              <input
                {...props.input}
                disabled={disabled}
                maxLength={maxLenght}
                placeholder={placeholder}
                autoFocus={autoFocus}
                value={value}
                className="input"
                onInput={(e: any) => onInput && onInput(e.target.value)}
                onChangeCapture={(e) => {
                  onChange && onChange(e);
                  onCustomChange && onCustomChange(e.currentTarget.value)
                }}
                onClick={onClick && onClick}
              />
              <span className="label">{label}</span>
              {!!rightIcon && (
                <Icon
                  icon={rightIcon}
                  className="rightIcon"
                  customSize={rightIconSize}
                  onClick={onRightIconClick && onRightIconClick}
                />
              )}
              <div className="errorInput errorCustomInput">
                {hasError(props.meta, disabled) ? props.meta.error : ''}
                {!hasError(props.meta, disabled) && outError ? outError : ''}
              </div>
            </LabelInput>
          )
        }
      ) : (
        !typeInput
          ? (props) => {
            props.meta.active ? onFocus && onFocus() : onBlur && onBlur();

            return (
              <LabelInput
                hidden={type === 'hidden'}
                className={className || ''}
                hasicon={!!icon}
                isdisabled={disabled}
                invalid={hasError(props.meta, disabled) && !props.meta.active}
                style={style}
                height={height}
              >
                {icon ? <Icon icon={icon} className="fieldIcon" /> : ''}
                <input
                  {...props.input}
                  disabled={disabled}
                  maxLength={maxLenght}
                  placeholder={placeholder}
                  autoFocus={autoFocus}
                  className="input"
                  onInput={(e: any) => onInput && onInput(e.target.value)}
                  onChangeCapture={(e) => {
                    onChange && onChange(e);
                    onCustomChange && onCustomChange(e.currentTarget.value)
                  }}
                  onClick={onClick && onClick}
                />
                <span className="label">{label}</span>
                {!!rightIcon && (
                  <Icon
                    icon={rightIcon}
                    className="rightIcon"
                    customSize={rightIconSize}
                    onClick={onRightIconClick && onRightIconClick}
                  />
                )}
                <div className="errorInput errorCustomInput">
                  {hasError(props.meta, disabled) ? props.meta.error : ''}
                  {!hasError(props.meta, disabled) && outError ? outError : ''}
                </div>
              </LabelInput>
            )
          }
          : (props) => {
            props.meta.active ? onFocus && onFocus() : onBlur && onBlur();

            return (
              <LabelInput
                hidden={type === 'hidden'}
                className={className || ''}
                hasicon={!!icon}
                isdisabled={disabled}
                invalid={hasError(props.meta, disabled) && !props.meta.active}
                style={style}
                height={height}
              >
                {icon ? <Icon icon={icon} className="fieldIcon" /> : ''}
                <textarea
                  {...props.input}
                  disabled={disabled}
                  maxLength={maxLenght}
                  placeholder={placeholder}
                  autoFocus={autoFocus}
                  className="input"
                  onInput={(e: any) => onInput && onInput(e.target.value)}
                  onChangeCapture={onChange}
                  onClick={onClick && onClick}
                />
                <span className="label">{label}</span>
                <div className="errorInput errorCustomInput">
                  {hasError(props.meta, disabled) ? props.meta.error : ''}
                </div>
              </LabelInput>
            )
          }
      )}
    </FieldReact>
  );
};

export default Field;
